var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import { withRouter } from "react-router";
import { SaveButton, CancelButton, } from "../../src/View/UI/StandardButtons/StandardButtons";
import MeetingType from "../../models/MeetingType";
import MeetingTypeService from "../../services/MeetingTypeService";
import Checkbox from "../shared/checkbox";
import { getMeetingTypeConfigurationIndexPath } from "../../src/View/Pages/Admin/MeetingTypeConfiguration/AdminMeetingTypeConfigurationRoutes";
class EditMeetingType extends PureComponent {
    constructor() {
        // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
        super();
        // @ts-expect-error - TS2416 - Property 'state' in type 'EditMeetingType' is not assignable to the same property in base type 'PureComponent<ContextRouter, State, any>'.
        this.state = {
            meetingType: new MeetingType(),
            isLoading: false,
            errors: [],
            isSaving: false,
            showSuccessMessage: false,
            successMessage: null,
            validationErrors: null,
        };
        this.save = this.save.bind(this);
        this.updateMeetingType = this.updateMeetingType.bind(this);
    }
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        // If there's an ID from the route, load up an existing meeting type.
        if (this.props.match.params.id) {
            this.getMeetingType(this.props.match.params.id);
        }
    }
    // @ts-expect-error - TS7006 - Parameter 'meetingTypeId' implicitly has an 'any' type.
    getMeetingType(meetingTypeId) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({
                isLoading: true,
                meetingType: new MeetingType(),
            });
            try {
                const meetingType = yield MeetingTypeService.fetchMeetingType(meetingTypeId);
                this.setState({ meetingType });
            }
            catch (e) {
                this.onError(e);
            }
            finally {
                this.setState({
                    isLoading: false,
                });
            }
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
    onError(error) {
        // Append the error to the list of errors on the state.
        this.setState({ errors: [...this.state.errors, error] });
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            // Validate the form.
            const errors = [];
            // Name is required.
            if (!this.state.meetingType.name.trim()) {
                errors.push("Name is required.");
            }
            // Duration is required, and must be greater than 0
            if (!this.state.meetingType.durationMinutes ||
                this.state.meetingType.durationMinutes <= 0) {
                errors.push("Duration must be greater than 0.");
            }
            this.setState({ validationErrors: errors });
            if (errors.length) {
                return;
            }
            this.setState({
                isSaving: true,
                showSuccessMessage: false,
                // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'string'.
                successMessage: null,
            });
            try {
                let response;
                if (this.props.match.params.id) {
                    response = yield MeetingTypeService.updateMeetingType(this.state.meetingType);
                }
                else {
                    response = yield MeetingTypeService.createMeetingType(this.state.meetingType);
                }
                if (response.success) {
                    this.setState({
                        meetingType: response.data,
                        showSuccessMessage: true,
                        successMessage: "Meeting Type saved",
                    });
                }
                else {
                    this.onError(response.message);
                }
            }
            catch (e) {
                this.onError(e);
            }
            finally {
                this.setState({ isSaving: false });
            }
            if (!errors.length) {
                this.props.history.push(getMeetingTypeConfigurationIndexPath());
            }
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'newProps' implicitly has an 'any' type.
    updateMeetingType(newProps) {
        // Update the meeting type by creating a clone of the original and updating it with the
        // properties on the object passed in.
        this.setState({
            meetingType: Object.assign(Object.assign({}, this.state.meetingType), newProps),
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type. | TS7006 - Parameter 'index' implicitly has an 'any' type.
    renderError(error, index) {
        return (_jsxs("div", { className: "alert alert-danger alert-dismissable", children: [_jsx("button", { type: "button", className: "close", "data-dismiss": "alert", "aria-label": "Close", children: _jsx("span", { "aria-hidden": "true", children: "\u00D7" }) }), _jsx("span", { className: "fa fa-exclamation-triangle", "aria-hidden": "true" }), " ", error] }, index));
    }
    // @ts-expect-error - TS7006 - Parameter 'errors' implicitly has an 'any' type.
    renderValidationErrors(errors) {
        if (errors && errors.length) {
            return (_jsxs("div", { className: "alert alert-warning", children: [_jsx("span", { className: "fa fa-exclamation-triangle", "aria-hidden": "true" }), " ", "Please correct the following problems.", _jsx("ul", { children: errors.map((error, index) => (_jsx("li", { children: error }, index))) })] }));
        }
        return "";
    }
    render() {
        const { history } = this.props;
        return (_jsx("div", { className: "container-fluid pb-3 pt-3", children: _jsxs("div", { children: [this.state.showSuccessMessage && (_jsxs("div", { className: "alert alert-success alert-rectangle", children: [_jsx("span", { className: "fa fa-check", "aria-hidden": "true" }), " ", this.state.successMessage] })), _jsx("div", { className: "title-block", children: _jsxs("h2", { className: "title", children: [_jsx("a", { href: getMeetingTypeConfigurationIndexPath(), className: "text-decoration-none", title: "Back_to_index", children: _jsx("span", { className: "fal fa-arrow-circle-left" }) }), " ", this.state.meetingType.id ? "Edit " : "New ", "Meeting Type"] }) }), _jsxs("div", { className: "form-group required", children: [_jsx("label", { htmlFor: "name", className: "font-weight-bold", children: "Name" }), _jsx("input", { type: "text", className: "form-control", id: "name", onChange: (event) => {
                                    this.updateMeetingType({ name: event.target.value });
                                }, value: this.state.meetingType.name, 
                                // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'boolean | undefined'.
                                required: "true" })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "info", className: "font-weight-bold", children: "Additional Info" }), _jsx("input", { type: "text", className: "form-control", id: "info", onChange: (event) => {
                                    this.updateMeetingType({ additionalInfo: event.target.value });
                                }, value: this.state.meetingType.additionalInfo })] }), _jsxs("div", { className: "form-group required", children: [_jsx("label", { htmlFor: "duration", className: "font-weight-bold", children: "Duration" }), _jsxs("div", { className: "d-flex flex-row align-items-baseline", children: [_jsx("input", { type: "number", step: "15", className: "form-control", style: { width: "75px" }, id: "duration", onChange: (event) => {
                                            this.updateMeetingType({
                                                durationMinutes: event.target.value,
                                            });
                                        }, value: this.state.meetingType.durationMinutes, 
                                        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'boolean | undefined'.
                                        required: "true" }), _jsx("span", { style: { marginLeft: "10px", marginTop: "13px" }, children: "minutes" })] })] }), _jsx("div", { className: "form-group", children: _jsx(Checkbox, { onChange: (event) => {
                                this.updateMeetingType({
                                    requiresLocation: event.target.checked,
                                });
                            }, checked: this.state.meetingType.requiresLocation, label: "Require student to meet at location" }) }), _jsx("div", { className: "form-group", children: _jsx(Checkbox, { onChange: (event) => {
                                this.updateMeetingType({ active: event.target.checked });
                            }, checked: this.state.meetingType.active, label: "Active" }) }), this.state.errors.map(this.renderError), this.renderValidationErrors(this.state.validationErrors), _jsxs("div", { children: [_jsx(SaveButton, { className: "mr-1", onClick: this.save, isLoading: this.state.isSaving }), _jsx(CancelButton, { onClick: () => {
                                    history.push(getMeetingTypeConfigurationIndexPath());
                                } })] })] }) }));
    }
}
export default withRouter(EditMeetingType);
